/* eslint-disable */
import setAdditionalMetaOptions from '@/js/common/Domain/Service/setAdditionalMetaOptions';
import requestService from './request';

const cache = {};
_.mixin({
    chunk(array, chunkSize) {
        return _.reduce(array, (reducer, item, index) => {
            reducer.current.push(item);
            if (reducer.current.length === chunkSize || index + 1 === array.length) {
                reducer.chunks.push(reducer.current);
                reducer.current = [];
            }
            return reducer;
        }, {current: [], chunks: []}).chunks;
    },
});

const getMinPriceByCriteriasService = function (options, callback) {
    const {tourCriterias} = options;
    const tourCriteriaHashesForRequest = [];
    let prices = [];

    const requestPricesPack = (tourCriteriaHashes) => requestService({
        url: `${window.appConfig.apiGatewayUrl}/frontend/prices/searchMinPriceByCriterias`,
        method: 'POST',
        data: {
            tourCriterias: tourCriteriaHashes,
            ...setAdditionalMetaOptions(),
        },
    }, {
        success(response) {
            if (response.success === true && response.result && response.result.length) {
                _.each(response.result, (criteriaPrice) => {
                    prices.push(criteriaPrice);
                    cache[criteriaPrice.criteria] = criteriaPrice.minPrice;
                });
            }

            callback?.success?.(prices);
        },
        error() {
            callback?.error?.();
        },
    });

    _.each(tourCriterias, (tourCriteria) => {
        const tourCriteriaHash = JSON.stringify(tourCriteria);
        if (!_.isUndefined(cache[tourCriteriaHash])) {
            prices.push({
                criteria: tourCriteriaHash,
                minPrice: cache[tourCriteriaHash],
            });
        } else {
            cache[tourCriteriaHash] = 0;
            tourCriteriaHashesForRequest.push(tourCriteriaHash);
        }
    });

    if (prices.length) {
        callback?.success?.(prices);
    }
    prices = [];
    if (tourCriteriaHashesForRequest.length) {
        _.each(_.chunk(tourCriteriaHashesForRequest, 5), (criterias) => {
            requestPricesPack(criterias);
        });
    }
};

export default getMinPriceByCriteriasService;